import { Injectable } from "@angular/core";
import { GTMService } from "./googleTagManager.service";
import { Actions, createEffect } from "@ngrx/effects";
import { filter, tap } from "rxjs/operators";
import { ActivatedRoute } from "@angular/router";
import { GTMEvents } from "./googleTagManager.consts";
import {
  productAddedEvent,
  productRemovedEvent,
  cartViewedEvent,
  checkoutStartedEvent,
  orderCompletedEvent,
  couponAppliedEvent,
} from "./googleTagManager.reducers";

@Injectable()
export class GTMChainEffects {
  constructor(
    readonly gtmService: GTMService,
    readonly actions$: Actions,
    readonly activatedRoute: ActivatedRoute
  ) {}

  readonly productAddedToCart = createEffect(
    () =>
      this.actions$.pipe(
        filter(productAddedEvent.match),
        tap((action: any) => {
          if (!!action?.value) {
            this.gtmService.pushEventTag(GTMEvents.PRODUCT_ADDED, action.value);
          }
        })
      ),
    { dispatch: false }
  );

  readonly producRemovedFromCart = createEffect(
    () =>
      this.actions$.pipe(
        filter(productRemovedEvent.match),
        tap((action: any) => {
          if (!!action?.value) {
            this.gtmService.pushEventTag(
              GTMEvents.PRODUCT_REMOVED,
              action.value
            );
          }
        })
      ),
    { dispatch: false }
  );

  readonly cartViewed = createEffect(
    () =>
      this.actions$.pipe(
        filter(cartViewedEvent.match),
        tap((action: any) => {
          if (!!action?.value) {
            this.gtmService.pushEventTag(GTMEvents.CART_VIEWED, action.value);
          }
        })
      ),
    { dispatch: false }
  );

  readonly checkoutStartedFromCart = createEffect(
    () =>
      this.actions$.pipe(
        filter(checkoutStartedEvent.match),
        tap((action: any) => {
          if (!!action?.value) {
            this.gtmService.pushEventTag(
              GTMEvents.CHECKOUT_STARTED,
              action.value
            );
          }
        })
      ),
    { dispatch: false }
  );

  readonly orderCompletedFromCart = createEffect(
    () =>
      this.actions$.pipe(
        filter(orderCompletedEvent.match),
        tap((action: any) => {
          if (!!action?.value) {
            this.gtmService.pushEventTag(
              GTMEvents.ORDER_COMPLETED,
              action.value
            );
          }
        })
      ),
    { dispatch: false }
  );

  readonly couponAppliedInCart = createEffect(
    () =>
      this.actions$.pipe(
        filter(couponAppliedEvent.match),
        tap((action: any) => {
          if (!!action?.value) {
            this.gtmService.pushEventTag(
              GTMEvents.COUPON_APPLIED,
              action.value
            );
          }
        })
      ),
    { dispatch: false }
  );
}
